import React from 'react';
import { Link } from "react-router-dom";
var bg_nine = require('../../assets/images/bg.jpeg');
var pic1 = require('../../assets/images/our-work/pic1.jpg');
var pic2 = require('../../assets/images/our-work/pic2.jpg');
var pic3 = require('../../assets/images/our-work/pic3.jpg');
const HomePlatformPlan = (props) => {	  	
    return(
	<>
	{/* <!-- OUR PRICING TABLE SECTION START  --> */}
	<div className="section-full overlay-wraper bg-center bg-cover p-t100 p-b70 site-bg-primary" style={{backgroundImage:`url(${bg_nine})`}}>
			<div className="container">
			
				{/* <!-- TITLE START--> */}
				<div className="section-head text-center">
					<h1><span className="site-text-primary">All-in-one  </span>  platform</h1>
					<div className="wt-separator-outer ">
						<div className="wt-separator style-icon">
							<i className="fa fa-leaf text-black"></i>
							<span className="separator-left site-bg-primary"></span>
							<span className="separator-right site-bg-primary"></span>
						</div>
					</div>
					<p>Excellent Infrastructure, Talented Faculty, Amazing Online Experience.</p>
				</div>
				{/* <!-- TITLE END--> */}
			 
				<div className="section-content">
					<div className="pricingtable-row">
						<div className="row d-flex justify-content-center">
						
							<div className="col-lg-4 col-md-4 col-sm-6 m-b30">
								<div className="pricingtable-wrapper pricing-table-style-4">
									<div className={`pricingtable-inner bg-white ${props.radius}`}>
										
										<div className="overlay-wraper pricingtable-inner-overlay bg-no-repeat bg-cover" style={{backgroundImage:`url(${pic1})`}}> 
											<div className="pricingtable-title">
												<h3>Academic Development</h3>
											</div>
											<div className="pricingtable-price">
												<span className="pricingtable-bx"> Overall Growth </span>
												
											</div>
											<div className="overlay-main bg-black opacity-07"></div>
										</div>
										
										
										<ul className="pricingtable-features">
											<li><i className="fa fa-check"></i>  We focus on Result and overall growth of the student. We make sure that the student performs in the right direction.
</li>
											<li><i className="fa fa-check"></i>Overall school growth encompasses multiple aspects, including academic achievements, sports, child all over development, student well-being, and positive learning environments.  </li>
										</ul>
										
										<div className="pricingtable-footer">
											<Link to="/shortcode-pricing-table" className={`site-button text-uppercase ${props.radiusSm}`}>See More</Link>
										</div>
									
									</div>
									
								</div>
							</div>
							
							<div className="col-lg-4 col-md-4 col-sm-6 m-b30">
								<div className="pricingtable-wrapper pricing-table-style-4">
									<div className={`pricingtable-inner bg-white ${props.radius}`}>
										
										<div className="overlay-wraper pricingtable-inner-overlay bg-no-repeat bg-cover" style={{backgroundImage:`url(${pic2})`}}> 
											<div className="pricingtable-title">
												<h3>Academy is experienced</h3>
											</div>
											<div className="pricingtable-price">
												<span className="pricingtable-bx">Expert Faculty</span>
												
											</div>
											<div className="overlay-main bg-black opacity-07"></div>
										</div>
										
										
										<ul className="pricingtable-features">
											<li><i className="fa fa-check"></i>Faculty at Golden Bells Academy is experienced and knows how to handle students well. We trust our Faculties as much as we trust ourselves.
 </li>
											<li><i className="fa fa-check"></i>In the context of schools, "expert faculty" generally refers to teachers who have demonstrated a high level of competence and expertise in their respective subjects or teaching areas. </li>
										</ul>
										
										<div className="pricingtable-footer">
											<Link to="/shortcode-pricing-table" className={`site-button text-uppercase ${props.radiusSm}`}>See More</Link>
										</div>
									
									</div>
									
								</div>
							</div>
							
							<div className="col-lg-4 col-md-4 col-sm-6 m-b30">
								<div className="pricingtable-wrapper pricing-table-style-4">
									<div className={`pricingtable-inner bg-white ${props.radius}`}>
										
										<div className="overlay-wraper pricingtable-inner-overlay bg-no-repeat bg-cover" style={{backgroundImage:`url(${pic3})`}}> 
											<div className="pricingtable-title">
												<h3>Digital Learning</h3>
											</div>
											<div className="pricingtable-price">
												<span className="pricingtable-bx">Online Learning</span>											
											</div>
											<div className="overlay-main bg-black opacity-07"></div>
										</div>
										
										
										<ul className="pricingtable-features">
											<li><i className="fa fa-check"></i>Online learning, also referred to as e-learning, digital learning or even sometimes virtual learning, encompasses a broad spectrum of educational activities facilitated through digital technologies.</li>
											<li><i className="fa fa-check"></i>Apart from the on premise education, we also provide online learning so that the student can learn from home also.</li>
											
											
										</ul>
										
										<div className="pricingtable-footer">
											<Link to="/shortcode-pricing-table" className={`site-button text-uppercase ${props.radiusSm}`}>See More</Link>
										</div>
									
									</div>
									
								</div>
							</div>
							
						</div>
					</div>
				</div>
			
			</div>
	</div>
	{/* <!-- OUR PRICING TABLEL SECTION END  --> */}   
    </>
    )
}
HomePlatformPlan.defaultProps = {
    radius: "radius",
	radiusSm: "radius-sm",
};
export default HomePlatformPlan;